import React from 'react';

const Slider = ({ min, max, step, value, onChange }) => {
  return (
    <div className="w-full">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
      />
      <div className="flex justify-between mt-1">
        <span className="text-xs text-gray-500">{min}%</span>
        <span className="text-xs text-gray-500">{max}%</span>
      </div>
    </div>
  );
};

export default Slider;